export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-4-c11164fda158591a4fd3056676a08608.png";